module.exports = __webpack_public_path__ + "Festool-vila.jpg?5bb20b53767f71d4accae81668ee92fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Festool-vila.jpg
// module id = 229
// module chunks = 0